// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + chunkId + ".js?v=" + {"923":"2686613ba9d88601b889","8321":"1e9a8023ef8296a459a5"}[chunkId] + "";
};